let iObserver = new IntersectionObserver(function(entries) {
	if (entries[0].isIntersecting === true) {
		loadMap();
	}
}, {threshold: [0]});


const mapFrame = document.getElementById('map')

if (mapFrame) {
	iObserver.observe(mapFrame);
}

function initMap() {
	ymaps
		.load()
		.then(maps => {
			const map = new maps.Map('map', {
				center: [55.751574, 37.573856],
				zoom: 9,
				controls: []
			});
			map.behaviors.disable("scrollZoom");
		})
		.catch(error => console.log('Failed to load Yandex Maps', error));
}

function loadMap() {
	let map = document.getElementById('map');
	if (!map.classList.contains("js--loaded")) {
		map.classList.add("'js--loaded");

		if (typeof ymaps === "undefined") {
			let js = document.createElement('script');
			js.src = "https://api-maps.yandex.ru/2.1/?lang=ru_RU";
			document.getElementsByTagName('head')[0].appendChild(js);
			js.onload = function() {
				//initMap()
				init()
			};
		}
	}
}



function init() {

	ymaps
		.load()
		.then(maps => {

			let myMap = new ymaps.Map('map', {
					center: [55.716326, 37.497953],
					zoom: 12,
					controls: ['zoomControl']
				});

			let logo = new ymaps.Placemark([55.716326, 37.497953], {}, {
					iconLayout: 'default#image',
					iconImageHref: 'images/map/g.svg',
					iconImageSize: [50, 50],
					iconImageOffset: [0, -50]
				});

			let objectManager = new ymaps.ObjectManager({
					clusterize: true,
					geoObjectOpenBalloonOnClick: true,
					clusterOpenBalloonOnClick: false
				});


			ymaps.option.presetStorage.add('my#universities', {
				iconLayout: 'default#image',
				iconImageHref: 'images/map/icon-1.svg',
				iconImageSize: [50,50],
				iconImageOffset: [0,-50]
			});

			ymaps.option.presetStorage.add('my#sport', {
				iconLayout: 'default#image',
				iconImageHref: 'images/map/icon-2.svg',
				iconImageSize: [50,50],
				iconImageOffset: [0,-50]
			});

			ymaps.option.presetStorage.add('my#shop', {
				iconLayout: 'default#image',
				iconImageHref: 'images/map/icon-3.svg',
				iconImageSize: [50,50],
				iconImageOffset: [0,-50]
			});

			ymaps.option.presetStorage.add('my#park', {
				iconLayout: 'default#image',
				iconImageHref: 'images/map/icon-4.svg',
				iconImageSize: [50,50],
				iconImageOffset: [0,-50]
			});

			ymaps.option.presetStorage.add('my#health', {
				iconLayout: 'default#image',
				iconImageHref: 'images/map/icon-5.svg',
				iconImageSize: [50,50],
				iconImageOffset: [0,-50]
			});

			ymaps.option.presetStorage.add('my#attractions', {
				iconLayout: 'default#image',
				iconImageHref: 'images/map/icon-6.svg',
				iconImageSize: [50,50],
				iconImageOffset: [0,-50]
			});

			ymaps.option.presetStorage.add('my#school', {
				iconLayout: 'default#image',
				iconImageHref: 'images/map/icon-7.svg',
				iconImageSize: [50,50],
				iconImageOffset: [0,-50]
			});


			myMap.events.add('click', e => e.get('target').balloon.close());

			var customBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
				'<div class=ballon_title>{{ properties.hintContent }}</div><div class=ballon_adress>{{ properties.adress }}</div>');

			objectManager.objects.options.set({
				balloonContentLayout: customBalloonContentLayout
			});


			let customClusterIconLayout = ymaps.templateLayoutFactory.createClass(
				'<div class="balloon__text">$[properties.geoObjects.length]</div>')

			let clusterIcons = [{
						href: 'images/map/bg.svg',
						size: [50, 50],
						offset: [0, -50]
					}];

			objectManager.clusters.options.set({
				clusterIcons: clusterIcons,
				clusterIconContentLayout: customClusterIconLayout,
			});


			myMap.geoObjects
				.add(objectManager)
				.add(logo);

			function getFilterFunction(categories) {
				return function (obj) {
					var content = obj.properties.balloonContent;
					return categories[content]
				}
			}

			const checkLabels = document.querySelectorAll('.map-checklist input');

			checkLabels.forEach(el => {
				el.addEventListener('click', () => {

					ob = {};
					var checkboxs = document.querySelectorAll('.map-checklist .checkbox-input:checked');

					checkboxs.forEach((item) => {
						ob[item.dataset.value] = true
					})

					objectManager.setFilter(getFilterFunction(ob));
				});
			});


			let response = fetch('data.json')
				.then(response => response.json())
				.then(json => objectManager.add(json))
				.catch(error => console.error(error))

		})
		.catch(error => console.log('Failed to load Yandex Maps', error));


}
